import { render, staticRenderFns } from "./HygieneOpportunitiesSkeleton.vue?vue&type=template&id=efaa05e8&scoped=true"
import script from "./HygieneOpportunitiesSkeleton.vue?vue&type=script&lang=js"
export * from "./HygieneOpportunitiesSkeleton.vue?vue&type=script&lang=js"
import style0 from "./HygieneOpportunitiesSkeleton.vue?vue&type=style&index=0&id=efaa05e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efaa05e8",
  null
  
)

export default component.exports